const config = {
    BASE_URL: "https://kazcop.kz"
}

export default config;